import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { OptionStatus, Product } from '@dch/products-business-logic';
import { getNspOption, INspValues } from '../utils/nsp.utils';
import { UpdateInternetNspValues } from '../store/actions/nsp.actions';
import { Store } from '@ngrx/store';

@Component({
  selector: 'mprd-nsp-internet-list-component',
  templateUrl: './nsp-internet-list-component.component.html',
})
export class NspInternetListComponentComponent implements OnChanges {
  @Input() products: Product[];

  public nspValues: INspValues = {};

  constructor(private store: Store) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes.hasOwnProperty('products') &&
      JSON.stringify(changes.products.previousValue) !==
        JSON.stringify(changes.products.currentValue)
    ) {
      this.fillNspValues();
    }
  }

  private fillNspValues() {
    this.products?.forEach((product: Product) => {
      const option = getNspOption(product);
      if (option) {
        this.nspValues = { ...this.nspValues };
        this.nspValues[product.accessNumber] = {
          accessNumber: product.accessNumber,
          value: true, // always selected
          active: option.ibStatus === OptionStatus.ACTIVE,
          trialOption: option.trialOption,
          chargeConfiguration: product.chargeConfiguration,
          plc: product.plc,
          installationAddress: product.installationAddress,
          mpcUuid: option.optionCodeForDescription,
          installationId: product.installationId,
        };
      }
      // init the store
      this.store.dispatch(new UpdateInternetNspValues(this.nspValues));
    });
  }

  public getNspKeys() {
    return Object.keys(this.nspValues);
  }
}
